<script>
  // You can pass any additional classes as a prop
  const { children, class: className = '' } = $props();
</script>

<div class="glass-background {className}">
  {@render children()}
</div>

<style>
  .glass-background {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 2px 2px 0 rgba(31, 38, 135, 0.1);
  }
</style>
